const pending = new Set();
const counted = new Map();
export async function pvCounter() {
  const settings = typeof bone_duck_pv_vars === 'undefined' ? null : bone_duck_pv_vars;
  if (!settings?.ajax_url || !settings.post_id) return;
  const key = `bone-duck-pv-${settings.post_id}`;
  const interval = Math.max(1, Number(settings.dedupe_minutes) || 30) * 60000;
  let last = counted.get(key) || 0;
  try {
    last = Number(sessionStorage.getItem(key)) || last;
  } catch {
    /* Storage may be blocked. */
  }
  if (pending.has(key) || (last && Date.now() - last < interval)) return;
  pending.add(key);
  const request = async (action, nonce) => {
    const data = new FormData();
    data.append('action', action);
    data.append('post_id', settings.post_id);
    if (nonce) data.append('nonce', nonce);
    const response = await fetch(settings.ajax_url, {
      method: 'POST',
      body: data,
      cache: 'no-store',
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error(`PV HTTP ${response.status}`);
    const result = await response.json();
    if (!result.success) throw new Error('PV request failed');
    return result.data;
  };
  try {
    const token = await request('bone_duck_pv_token');
    if (typeof token?.nonce !== 'string' || !token.nonce) throw new Error('Missing PV token');
    await request('bone_duck_increment_post_views', token.nonce);
    const now = Date.now();
    counted.set(key, now);
    try {
      sessionStorage.setItem(key, String(now));
    } catch {
      /* Use in-memory deduplication. */
    }
  } catch (error) {
    if (settings.debug) console.warn('PVカウントを更新できませんでした。', error);
  } finally {
    pending.delete(key);
  }
}
